const AUTH_TOKEN_KEY = 'token';

const storeAuthToken = token => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

const removeAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

export {storeAuthToken, getAuthToken, removeAuthToken};
